import { createRoot } from "react-dom/client";
import { buildLDProvider } from "@equidefi/portals/providers/LaunchDarkly";

import App from "./App";
import { CONFIG } from "./constants/config";
import { sentryStart } from "./helpers/sentry";
import { IssuerColorMode, IssuerQueryProvider } from "./providers";
import { ApiClientProvider } from "@equidefi/portals/context/ApiClientProvider";
import AuthProvider from "@equidefi/portals/context/AuthProvider";

// css
import "./style/app.css";
import "./style/custom.css";
import "./style/fonts.css";
import "./style/icons.css";

sentryStart();

const container = document.getElementById("root");
const root = createRoot(container);

const renderApp = async () => {
  const IssuerFeatureFlagProvider = await buildLDProvider(CONFIG.LAUNCH_DARKLY_CLIENT_ID);

  root.render(
    <IssuerFeatureFlagProvider>
      <IssuerColorMode />
      <IssuerQueryProvider>
        <AuthProvider>
          <ApiClientProvider apiUrl={CONFIG.EQ_API_URL}>
            <App />
          </ApiClientProvider>
        </AuthProvider>
      </IssuerQueryProvider>
    </IssuerFeatureFlagProvider>,
  );
};

renderApp();
